// 模块
export default {
	home: {
		name: "首頁"
	},
	page_out_trade_no: "商戶單號",
	submit_modeling_model_file_not_ready: "模型文件暫未準備完成，請稍後重試或聯繫客服處理"
};
